import { render, staticRenderFns } from "./photoGallaryView.vue?vue&type=template&id=4b56a669"
import script from "./photoGallaryView.vue?vue&type=script&lang=js"
export * from "./photoGallaryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports